<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      fixed
      app
    >
      <v-list
        two-line
      >
        <v-list-tile>
          <logo></logo>
        </v-list-tile>

        <v-list-tile>
          <v-btn
            router
            :to="{ name: 'search-add'}"
            color="primary"
            class="mx-auto"
          >
            <v-icon left>add_alert</v-icon>
            Start tracking
          </v-btn>
        </v-list-tile>

        <active-search></active-search>

        <main-menu></main-menu>

      </v-list>
    </v-navigation-drawer>
    <v-toolbar fixed app>
      <v-toolbar-side-icon @click="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        flat
        @click="dashboard()">
        Dashboard
      </v-btn>
      <v-btn
        flat
        @click="profile()">
        Profile
      </v-btn>
      <v-btn
        icon
        @click="logout()"
      >
        <v-icon>settings_power</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
  import { logout } from '@/services/auth'
  import Logo from '@/components/common/Logo'
  import MainMenu from '@/components/common/MainMenu'
  import SearchList from '@/components/search/SearchList'
  import ActiveSearch from '@/components/search/ActiveSearch'

  export default {
    data () {
      return {
        clipped: true,
        drawer: true,
        fixed: false,
        miniVariant: false,
        right: true,
        rightDrawer: false
      }
    },
    methods: {
      logout () {
        logout()
      },
      profile () {
        this.$router.push({name: 'profile'})
      },
      dashboard () {
        this.$router.push({name: 'dashboard'})
      }
    },
    computed: {
      title () {
        return this.$store.getters['pages/title']
      }
    },
    created () {
      this.$store.dispatch('search/getSearches')
    },
    components: {
      Logo,
      SearchList,
      MainMenu,
      ActiveSearch
    }
  }
</script>


// WEBPACK FOOTER //
// src/layouts/default.vue